module.exports = "<!-- @license lucide-static v1.14.0 - ISC -->\n<svg\n  class=\"lucide lucide-upload\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n  width=\"24\"\n  height=\"24\"\n  viewBox=\"0 0 24 24\"\n  fill=\"none\"\n  stroke=\"currentColor\"\n  stroke-width=\"2\"\n  stroke-linecap=\"round\"\n  stroke-linejoin=\"round\"\n>\n  <path d=\"M12 3v12\" />\n  <path d=\"m17 8-5-5-5 5\" />\n  <path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/lucide-static/icons/upload.svg
// module id = 1594
// module chunks = 0